import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
import i18n from "@/plugins/i18n";

enum TextType {
  STRING,
  ARRAY
}


export default /*#__PURE__*/_defineComponent({
  __name: 'WarningMessage',
  props: {
    header: { type: String, required: true },
    headerVariables: { type: null, required: true },
    texts: { type: String, required: true },
    textsVariables: { type: null, required: true }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props;

const textTypeData = computed(() => getTextsLength(props.texts));

function getTextsLength(key: string): {type: TextType | undefined, amount: number } {
  const split = key.split('.');
  // console.log("locale:" + JSON.stringify(i18n.global.locale.value));
  let result: any = i18n.global.getLocaleMessage(i18n.global.locale.value);
  split.forEach((s) => {
    result = result[s];
    if (!result) {
      return {
        type: undefined,
        amount: 0
      };
    }
  });
  if (typeof result === 'string') {
    return {
      type: TextType.STRING,
      amount: 1
    };
  } else if ( result instanceof Array) {
    return {
      type: TextType.ARRAY,
      amount: result.length
    };
  }
  return {
    type: undefined,
    amount: 0
  };
}

const __returned__ = { props, textTypeData, TextType, getTextsLength }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})